<template>
  <div>
    <base-header class="pb-8 pt-4">
      <!-- Card stats -->
      <div class="row invoice-card-row">
        <div class="col-xl-6 col-xxl-6 col-sm-12">
          <div class="card bg-success invoice-card">
            <div class="card-body d-flex">
              <div class="icon mr-3">
                <i class="fas fa-chart-bar text-white mt-2"></i>
              </div>
              <div>
                <h2 class="text-white invoice-num">{{ productsCount }}</h2>
                <span class="text-white fs-18">Ürün</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <h3 class="card-title mb-0">Ürün Yönetimi</h3>
          <div class="align-items-center row mt-2">
            <div class="col-12 d-flex flex-wrap align-items-center" style="gap: 10px;">
              <div class="text-sm" style="width: 170px">
                <b-form-group class="mb-0">
                  <b-form-input placeholder="Ürün adı" v-model="keyword" debounce="500" />
                </b-form-group>
              </div>
            </div>
            <div class="col-12 text-right mt-3">
              <b-button @click="
                service = { tax: 0, used_time: 0 };
              $refs.modal.show();
              " class="btn-sm" variant="primary">+ {{ $t('Yeni Ürün Ekle') }}
              </b-button>
            </div>
          </div>
        </b-card-header>

        <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="getItems"
          responsive show-empty>
          <template v-slot:table-busy>
            <div style="width: 100%; text-align: center">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>
          <template v-slot:cell(thumbnail)="data">
            <a href="#" class="text-underline" @click.prevent="openLightBox(data.item.images)">
              <img v-if="data.item.images && data.item.images.length > 0" :src="data.item.images[0].url"
                class="thumbnail-image" alt="Resim" style="width: 100px !important; height: auto">
              <span v-else>Resim yok</span> <!-- Eğer resim yoksa bir mesaj gösterebilirsiniz -->
            </a>
          </template>
          <template v-slot:empty>
            <b-alert variant="warning" show>{{ $t('Henüz bir şey eklenmemiş') }}!
            </b-alert>
          </template>


          <template v-slot:cell(actions)="data">
            <div class="d-flex flex-column">
              <b-button variant="info" size="sm" @click.prevent="editService(data.item)" class="btn-block mb-1">
                {{ $t('Düzenle') }}
              </b-button>
              <b-button variant="danger" size="sm" @click.prevent="deleteAction(data.item.id)" class="btn-block mb-1">
                {{ $t('Sil') }}
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="w-100 text-center d-flex-wrap align-items-center justify-content-center mt-2 mb-3">
          <b-button variant="secondary" v-if="cPage != 1" @click="
            cPage = 1;
          refreshTable();
          ">
            << </b-button>
              <b-button variant="secondary" v-if="cPage != 1" @click="
                cPage - 10 >= 1 ? (cPage = cPage - 10) : (cPage = 1);
              refreshTable();
              ">
                < </b-button>
                  <b-button :variant="cPage == page ? 'primary' : 'secondary'" v-for="page in services.last_page"
                    @click="
                      cPage = page;
                    refreshTable();
                    " v-bind:key="page" v-if="page < cPage + 5 && page > cPage - 5">
                    {{ page }}
                  </b-button>

                  <b-button variant="secondary" v-if="cPage != services.last_page" @click="
                    cPage + 10 <= services.last_page
                      ? (cPage = cPage + 10)
                      : (cPage = services.last_page);
                  refreshTable();
                  ">
                    >
                  </b-button>
                  <b-button variant="secondary" v-if="cPage != services.last_page" @click="
                    cPage = services.last_page;
                  refreshTable();
                  ">
                    >>
                  </b-button>
        </div>
      </b-card>
    </div>

    <b-modal ref="modal" title="Ürün Kaydı" @hide="resetModal">
      <b-form-group label="Ürün Resmi">
        <b-form-file v-model="upload_logo" @change="uploadLogo" accept="image/jpeg, image/png" multiple></b-form-file>
        <ul v-if="service.images && service.images.length">
          <li v-for="(img, k) in service.images" :key="k">
            <a :href="img['url'] ? img['url'] : img" target="_blank">
              {{ $t("Görsel") }} {{ k + 1 }}
            </a>
            <button class="btn btn-sm btn-danger text-white mt-1" @click.prevent="deleteImage(img['url'] || img, k)"
              style="margin-left: 10px; color: red;">
              {{ $t("Sil") }}
            </button>
          </li>
        </ul>

      </b-form-group>

      <b-row>
        <b-col>
          <b-form-group label="Ürün Adı">
            <b-form-input required v-model="service.name" />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- <b-form-group>
        <legend
            tabindex="-1"
            class="bv-no-focus-ring col-form-label pt-0"
            id="__BVID__214__BV_label_"
        >
          Stok
          <span style="font-size: 12px"
          >{{ $t('Limitsiz için') }}
            <b-badge variant="default">-1</b-badge> {{ $t('girin') }}</span
          >
        </legend>
        <b-form-input v-model="service.stock"/>
      </b-form-group> -->
      <b-row>
        <b-col>
          <b-form-group label="Sıralama">
            <b-form-input v-model="service.ranking" type="number"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Ölçü (Ör. 70gr, 1 Litre)">
            <b-form-input v-model="service.measure" type="text"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Miktar (Ör. 1 Adet, 1 Porsiyon)">
            <b-form-input v-model="service.amount" type="text"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Satış Fiyatı">
            <b-form-input v-model="service.price" type="number"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Paket Satış Fiyatı">
            <b-form-input v-model="service.package_price" type="number"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="resetAndHideModal">{{
          $t('İptal')
        }}
        </b-button>
        <b-button variant="primary" @click="submitModal">{{ $t('Kaydet') }}
        </b-button>
      </template>
    </b-modal>

    <b-modal ref="newBrandModal" title="Yeni Marka" @hide="hideNewBrandModal">
      <b-form-group label="Başlık">
        <b-form-input v-model="newBrand"></b-form-input>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button @click="$refs.newBrandModal.hide()">İptal</b-button>
        <b-button @click="submitNewModal()" variant="primary" class="loading-button">
          <i v-if="buttonLoading" class="fa fa-spinner"></i> {{ $t('Kaydet') }}
        </b-button>
      </template>
    </b-modal>

    <vue-easy-lightbox :visible="showLightBox" :imgs="media" @hide="closeLightBox"></vue-easy-lightbox>
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Switches from 'vue-switches';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { imageBase } from '../../config';
import VueQr from 'vue-qr';
import request from '../../request';

export default {
  components: { Switches, VueQr },
  validations: {
    service: {
      name: { required },
      price: { required },
      tax: { required },
    },
  },
  computed: {
    ...mapGetters(['user']),

    baseURL() {
      return imageBase;
    },
    base() {
      return window.location.origin;
    },
    getType() {
      return this.$route.params.type;
    },
    fields() {
      let fields = [
        { key: 'thumbnail', label: 'Görsel' },
        { key: 'ranking', label: 'Sıralama' },
        { key: 'name', label: 'Ürün Adı' },
        { key: 'measure', label: 'Ölçü' },
        { key: 'amount', label: 'Miktar' },
        { key: 'price', label: 'Satış Fiyatı' },
        { key: 'package_price', label: 'Paket Satış Fiyatı' },
      ];
      fields.push({ key: 'actions', label: '', tdClass: 'text-right' });
      return fields;
    },
  },

  mounted() {
  },
  data() {
    return {
      showLightBox: false,
      rentFilter: "all",
      similar_companies: [],
      sizeFilter: '',
      reportLoading: false,
      newBrand: '',
      companies: [],
      buttonLoading: false,
      company: null,
      perPage: 7,
      keyword: '',
      cPage: 1,
      orderByStock: false,
      submitType: 'create',
      services: [],
      id: '',
      monthlyLeaseCount: 0,
      product: '',
      activeItem: '',
      barcodeHTML: '',
      service: {
        images: [],
        name: '',
        price: '',
        package_price: '',
        amount: '',
        measure: '',
        ranking: '',
        stock: '',
      },
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 15,
      },
      isAltCategory: false,
      altCategory: [],
      selectedAltCategory: null,
      allAltCategories: [],
    };
  },
  created() {
    if (!this.user.yearsize_permission) {
      this.fields = this.fields.filter(
        (field) => field.key != 'size' && field.key != 'year'
      );
    }
    if (this.type != 'all') {
      this.fields = this.fields.filter((field) => field.key != 'bayi');
    }
  },
  methods: {
    ...mapActions([
      'uploadPhoto',
      'getServices',
      'getDeletedServices',
      'createService',
      'updateService',
      'deleteService',
    ]),
    openLightBox(images) {
      this.media = images.map(i => i.url);
      this.showLightBox = true;
    },
    closeLightBox() {
      this.showLightBox = false;
    },
    uploadLogo(e) {
      if (!this.service.images) {
        this.service.images = [];
      }
      for (let i = 0; i < e.target.files.length; i++) {
        const formData = new FormData();
        formData.append("file", e.target.files[i]);
        this.uploadPhoto(formData).then(response => {
          this.service.images.push(response.data.file_url);
        });
      }
      this.upload_logo = null;
    },
    changeBrandSelect() {
      if (this.service.brand_id == null) {
        this.$refs.newBrandModal.show();
      }
    },
    hideNewBrandModal() {
      this.getItems();
    },

    submitModal() {
      if (this.submitType === 'update') {
        this.updateService({
          id: this.id,
          service: this.service,
        })
          .then((response) => {
            this.success(response.data.message);
            this.hideModal();
            this.refreshTable();
          })
          .catch((error) => {
            this.format(error.response.data.errors).forEach((item) => {
              this.error(item);
            });
          });
      } else {
        this.createService(this.service)
          .then((response) => {
            this.success(response.data.message);
            this.hideModal();
            this.refreshTable();
          })
          .catch((error) => {
            this.format(error.response.data.errors).forEach((item) => {
              this.error(item);
            });
          });
      }
    },
    format(obj) {
      return [].concat(Object.values(obj)).flat(10);
    },
    editService(service) {
      this.submitType = 'update';
      const item = JSON.parse(JSON.stringify(service));
      this.id = item.id;
      this.service = item;
      this.openModal();
    },
    deleteImage(url, index) {
      request
        .post('/delete-image-by-url', { url: url })
        .then((res) => {
          // Only remove the image if the request was successful
          this.service.images.splice(index, 1);
        })
        .catch((error) => {
        });
    },

    deleteAction(id) {
      this.$swal({
        icon: 'warning',
        title: 'Dikkat',
        text: 'Hizmet kalici olarak silinecektir, emin misiniz?',
      }).then((ok) => {
        if (ok.value) {
          this.deleteService(id)
            .then((response) => {
              this.success(response.data.message);
              this.refreshTable();
            })
            .catch((error) => {
              this.error(error.response.data.message);
            });
        }
      });
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    getItems() {
      const parameters = this.parameters();
      return this.getServices(parameters)
        .then((data) => data.data)
        .then((response) => {
          this.similar_companies = response.similar_companies;
          const services = response.services;
          this.productsCount = response.products_count;
          this.services = services;
          this.pagination.totalRows = services.total;
          return services.data;
        });
    },
    parameters() {
      const params = {};
      if (this.getType == 'all') params.getType = 'all';
      params.page = this.cPage;
      params.perPage = this.perPage;
      if (this.keyword.length > 0) {
        params.keyword = this.keyword;
      }
      if (this.sizeFilter.length > 0) {
        params.size = this.sizeFilter;
      }
      return params;
    },
    resetAndHideModal() {
      this.resetModal();
      this.hideModal();
    },
    openModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
    },
    resetModal() {

      this.submitType = 'create';
      this.service = {
        images: [],
        title: '',
        price: '',
      };
    },
  },
  watch: {
    keyword() {
      this.refreshTable();
    },
    sizeFilter() {
      this.refreshTable();
    },
  },
};
</script>


<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

html {
  overflow: -moz-scrollbars-horizontal !important;
  overflow-x: hidden !important;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>